import React from 'react';

import { ButtonIcon } from '@/components/shared/buttons/button-icon';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Flex } from '@/components/shared/layout/flex';

interface DealerPanelHeaderProps {
  headerText: string;
  onClose: () => void;
}

export const DealerPanelHeader: React.FunctionComponent<
  DealerPanelHeaderProps
> = (props: DealerPanelHeaderProps) => {
  return (
    <Box
      paddingX={{
        '@initial': '4',
        '@xs': '6',
        '@2xl': '7',
      }}
      paddingY="4"
      backgroundColor="red"
    >
      <Flex wrap="nowrap" justifyContent="between" alignItems="center" gap="6">
        {!!props.headerText && (
          <Text
            as="h3"
            size="text-body-1"
            font="bold"
            variant="text-white"
            css={{ paddingTop: '2px' }}
          >
            {props.headerText}
          </Text>
        )}
        <ButtonIcon
          icon="close"
          variant="button-icon-color-white"
          size="md"
          border
          onClick={props.onClose}
          test={{ dataTest: 'button_closeResultPanel' }}
        />
      </Flex>
    </Box>
  );
};

DealerPanelHeader.displayName = 'SectionDealerPanelHeader';
